import { Link } from 'react-router-dom'
import { ArrowRight, BookOpen, Users, Target, CheckCircle, MessageCircle, Award, TrendingUp } from 'lucide-react'

export default function LandingPage() {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-br from-education via-education/90 to-action pt-20 pb-24">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4xIj48cGF0aCBkPSJNMzYgMzRjMC0yLjIxLTEuNzktNC00LTRzLTQgMS43OS00IDQgMS43OSA0IDQgNCA0LTEuNzkgNC00em0wLTEwYzAtMi4yMS0xLjc5LTQtNC00cy00IDEuNzktNCA0IDEuNzkgNCA0IDQgNC0xLjc5IDQtNHoiLz48L2c+PC9nPjwvc3ZnPg==')] opacity-10"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <div className="inline-flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center shadow-lg">
                <BookOpen className="w-7 h-7 text-education" />
              </div>
              <h1 className="text-3xl font-bold text-white">Learn to Lead Change</h1>
            </div>
            
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Unete a la plataforma donde tu<br />
              <span className="text-action">aprendizaje se transforma</span><br />
              en accion civica
            </h2>
            
            <p className="text-xl md:text-2xl text-white/90 mb-10 max-w-3xl mx-auto">
              Accede a formacion en accion social y participa en campanas reales para tu comunidad
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link
                to="/registro"
                className="group px-8 py-4 bg-white text-education rounded-xl font-semibold text-lg hover:bg-action hover:text-white transition-all shadow-xl hover:shadow-2xl transform hover:scale-105"
              >
                Hacerte socio gratis
                <ArrowRight className="inline-block ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link
                to="/login"
                className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white rounded-xl font-semibold text-lg hover:bg-white hover:text-education transition-all"
              >
                Inicia sesion
              </Link>
            </div>
            
            <div className="mt-12 flex flex-wrap justify-center gap-8 text-white/90">
              <div className="flex items-center gap-2">
                <CheckCircle className="w-5 h-5 text-action" />
                <span>Gratis para siempre</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle className="w-5 h-5 text-action" />
                <span>Sin tarjeta requerida</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle className="w-5 h-5 text-action" />
                <span>Certificados incluidos</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quienes Somos */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Quienes somos</h2>
              <p className="text-lg text-gray-700 mb-4">
                <strong>Learn to Lead Change</strong> es una plataforma innovadora que combina formacion de calidad 
                con participacion civica real. No solo aprendes sobre los problemas que afectan a tu comunidad, 
                sino que tambien te damos las herramientas para hacer algo al respecto.
              </p>
              <p className="text-lg text-gray-700 mb-4">
                Creemos que el cambio social comienza con educacion y se materializa con accion. Por eso, cada 
                curso esta vinculado a campanas reales donde puedes aplicar lo aprendido y generar impacto tangible.
              </p>
              <p className="text-lg text-gray-700">
                Nuestra comunidad esta formada por personas comprometidas que quieren marcar la diferencia. 
                Juntos, estamos construyendo un movimiento de cambio desde lo local hacia lo global.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-education/5 rounded-2xl p-6 text-center">
                <div className="text-4xl font-bold text-education mb-2">12K+</div>
                <div className="text-gray-700">Socios activos</div>
              </div>
              <div className="bg-action/5 rounded-2xl p-6 text-center">
                <div className="text-4xl font-bold text-action mb-2">350+</div>
                <div className="text-gray-700">Campanas exitosas</div>
              </div>
              <div className="bg-urgency/5 rounded-2xl p-6 text-center">
                <div className="text-4xl font-bold text-urgency mb-2">85</div>
                <div className="text-gray-700">Cursos disponibles</div>
              </div>
              <div className="bg-community/5 rounded-2xl p-6 text-center">
                <div className="text-4xl font-bold text-community mb-2">40</div>
                <div className="text-gray-700">Ciudades activas</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Ventajas Exclusivas */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Ventajas exclusivas para socios</h2>
            <p className="text-xl text-gray-600">Todo lo que obtienes al unirte a nuestra comunidad</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-14 h-14 bg-education/10 rounded-xl flex items-center justify-center mb-6">
                <BookOpen className="w-7 h-7 text-education" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Cursos Ilimitados</h3>
              <p className="text-gray-700 mb-4">
                Acceso completo a todos los cursos sobre accion climatica, participacion ciudadana, derechos humanos y mas.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-action flex-shrink-0 mt-0.5" />
                  <span>Videos de alta calidad</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-action flex-shrink-0 mt-0.5" />
                  <span>Material descargable</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-action flex-shrink-0 mt-0.5" />
                  <span>Certificados oficiales</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-14 h-14 bg-action/10 rounded-xl flex items-center justify-center mb-6">
                <Target className="w-7 h-7 text-action" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Campanas Reales</h3>
              <p className="text-gray-700 mb-4">
                Participa en iniciativas que generan cambios tangibles en tu comunidad y mas alla.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-action flex-shrink-0 mt-0.5" />
                  <span>Firma peticiones con impacto</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-action flex-shrink-0 mt-0.5" />
                  <span>Organiza eventos locales</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-action flex-shrink-0 mt-0.5" />
                  <span>Ve tu impacto en tiempo real</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-14 h-14 bg-community/10 rounded-xl flex items-center justify-center mb-6">
                <Users className="w-7 h-7 text-community" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Comunidad Privada</h3>
              <p className="text-gray-700 mb-4">
                Conecta con personas comprometidas, comparte experiencias y colabora en proyectos.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-action flex-shrink-0 mt-0.5" />
                  <span>Foros especializados</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-action flex-shrink-0 mt-0.5" />
                  <span>Networking con activistas</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-action flex-shrink-0 mt-0.5" />
                  <span>Mentorias y apoyo</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Testimonios */}
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Lo que dicen nuestros socios</h3>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="border-l-4 border-education pl-6">
                <p className="text-gray-700 italic mb-4">
                  "Gracias a esta plataforma no solo aprendi sobre cambio climatico, tambien participe en la campana 
                  que trajo paneles solares a mi municipio."
                </p>
                <div className="font-semibold text-gray-900">Maria L.</div>
                <div className="text-sm text-gray-600">Valencia</div>
              </div>
              <div className="border-l-4 border-action pl-6">
                <p className="text-gray-700 italic mb-4">
                  "La comunidad es increible. He encontrado personas con mis mismos valores y juntos estamos 
                  haciendo cosas que nunca pense posibles."
                </p>
                <div className="font-semibold text-gray-900">Carlos R.</div>
                <div className="text-sm text-gray-600">Barcelona</div>
              </div>
              <div className="border-l-4 border-community pl-6">
                <p className="text-gray-700 italic mb-4">
                  "Los certificados me han ayudado profesionalmente, pero lo mejor es saber que realmente estoy 
                  contribuyendo al cambio."
                </p>
                <div className="font-semibold text-gray-900">Ana P.</div>
                <div className="text-sm text-gray-600">Madrid</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Como Funciona */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Como funciona</h2>
            <p className="text-xl text-gray-600">Tu viaje del aprendizaje al impacto en 4 pasos</p>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-education rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg">
                <span className="text-3xl font-bold text-white">1</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Te asocias</h3>
              <p className="text-gray-600">
                Registro gratuito en menos de 2 minutos. Sin tarjeta, sin compromisos.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-action rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg">
                <span className="text-3xl font-bold text-white">2</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Accedes y aprendes</h3>
              <p className="text-gray-600">
                Explora cursos, participa en foros y conecta con la comunidad.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-urgency rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg">
                <span className="text-3xl font-bold text-white">3</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Participas en campanas</h3>
              <p className="text-gray-600">
                Aplica lo aprendido en proyectos y campanas reales con impacto medible.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-community rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg">
                <span className="text-3xl font-bold text-white">4</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Ves tu impacto</h3>
              <p className="text-gray-600">
                Recibe certificados, badges y estadisticas de tu contribucion al cambio.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Proximos Cursos y Campanas */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Proximamente en la plataforma</h2>
            <p className="text-xl text-gray-600">Un adelanto de lo que te espera como socio</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-education/20">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-education/10 rounded-xl flex items-center justify-center">
                  <BookOpen className="w-6 h-6 text-education" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-education">CURSO</div>
                  <h3 className="text-xl font-bold text-gray-900">Accion Climatica Local</h3>
                </div>
              </div>
              <p className="text-gray-700 mb-4">
                Aprende estrategias practicas para combatir el cambio climatico desde tu comunidad. 
                Incluye modulos sobre energia renovable, movilidad sostenible y economia circular.
              </p>
              <div className="flex items-center gap-4 text-sm text-gray-600">
                <span className="flex items-center gap-1">
                  <Award className="w-4 h-4" />
                  Certificado oficial
                </span>
                <span className="flex items-center gap-1">
                  <TrendingUp className="w-4 h-4" />
                  20 horas
                </span>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-action/20">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-action/10 rounded-xl flex items-center justify-center">
                  <Target className="w-6 h-6 text-action" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-action">CAMPANA</div>
                  <h3 className="text-xl font-bold text-gray-900">Mas arboles en tu municipio</h3>
                </div>
              </div>
              <p className="text-gray-700 mb-4">
                Participa en nuestra iniciativa nacional para aumentar las zonas verdes urbanas. 
                Firma la peticion y organiza eventos de plantacion en tu ciudad.
              </p>
              <div className="flex items-center gap-4 text-sm text-gray-600">
                <span className="flex items-center gap-1">
                  <Users className="w-4 h-4" />
                  8,500 firmantes
                </span>
                <span className="flex items-center gap-1">
                  <MessageCircle className="w-4 h-4" />
                  45 ciudades
                </span>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <p className="text-gray-600 mb-6">
              Descubre cientos de cursos y campanas mas dentro de la plataforma
            </p>
            <Link
              to="/registro"
              className="inline-flex items-center gap-2 px-8 py-4 bg-education text-white rounded-xl font-semibold text-lg hover:bg-education/90 transition-all shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              Accede ahora gratis
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center">Preguntas frecuentes</h2>
          
          <div className="space-y-6">
            <div className="bg-gray-50 rounded-xl p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Que implica asociarse?</h3>
              <p className="text-gray-700">
                Asociarse es completamente gratuito y te da acceso a todos los cursos, campanas y la comunidad privada. 
                No hay cuotas mensuales ni cargos ocultos. Solo necesitas un email valido para registrarte.
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Realmente es gratis?</h3>
              <p className="text-gray-700">
                Si, completamente gratis. Nuestra plataforma se financia mediante donaciones voluntarias y alianzas 
                con organizaciones que comparten nuestra vision. Puedes contribuir voluntariamente si lo deseas, 
                pero nunca es obligatorio.
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Mis datos estan seguros?</h3>
              <p className="text-gray-700">
                Absolutamente. Cumplimos con la normativa RGPD y nunca compartimos tus datos con terceros. 
                Tienes control total sobre tu informacion y puedes eliminar tu cuenta en cualquier momento.
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Los certificados son oficiales?</h3>
              <p className="text-gray-700">
                Si, emitimos certificados oficiales verificables al completar cada curso. Estos certificados 
                son reconocidos por organizaciones sociales y pueden ser incluidos en tu CV y LinkedIn.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-20 bg-gradient-to-r from-education to-action">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            El cambio comienza contigo
          </h2>
          <p className="text-xl text-white/90 mb-10">
            Unete a miles de personas que ya estan transformando sus comunidades
          </p>
          <Link
            to="/registro"
            className="inline-flex items-center gap-2 px-10 py-5 bg-white text-education rounded-xl font-bold text-xl hover:bg-gray-50 transition-all shadow-2xl transform hover:scale-105"
          >
            Comienza tu viaje gratis
            <ArrowRight className="w-6 h-6" />
          </Link>
        </div>
      </section>
    </div>
  )
}
